// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  padding: 1rem;
}

.form-section {
  /* border: 3px solid var(--formBorderLineColor); */
  border-radius: 10px;
  margin-bottom: 2rem;
  padding: 1.5rem;
  position: relative;
  width: 100%;
  /* background-color: #fff; */
}

.form-legend {
  color:  var(--gradientColor2);
  font-size: 16px;
  font-weight: bold;
  padding: 0 10px;
  margin-left: 1rem;
}

.inputs-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 1 1 300px;
}

.label {
  font-size: 14px;
  margin-bottom: 0.25rem;
  color: #333;
}

.required {
  color:  var(--gradientColor2);
  margin-left: 2px;
}

.input {
  background-color: #edf0f5;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
}

.add-video {
  margin-top: 1rem;
}

.add-btn {
  background-color:  var(--gradientColor2);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/utils/NewFormStructure/FormSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".form-container {\r\n  padding: 1rem;\r\n}\r\n\r\n.form-section {\r\n  /* border: 3px solid var(--formBorderLineColor); */\r\n  border-radius: 10px;\r\n  margin-bottom: 2rem;\r\n  padding: 1.5rem;\r\n  position: relative;\r\n  width: 100%;\r\n  /* background-color: #fff; */\r\n}\r\n\r\n.form-legend {\r\n  color:  var(--gradientColor2);\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  padding: 0 10px;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.inputs-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 300px;\r\n}\r\n\r\n.label {\r\n  font-size: 14px;\r\n  margin-bottom: 0.25rem;\r\n  color: #333;\r\n}\r\n\r\n.required {\r\n  color:  var(--gradientColor2);\r\n  margin-left: 2px;\r\n}\r\n\r\n.input {\r\n  background-color: #edf0f5;\r\n  padding: 0.5rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n}\r\n\r\n.add-video {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.add-btn {\r\n  background-color:  var(--gradientColor2);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
